export const UNCHANGED_STATE = 'UNCHANGED';
